import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AssetService {
  removeScript(path: string) {
    // TODO: Remove DOM element that has attribute `data-path="${path}"`
  }

  loadScript(path: string): Promise<any> {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = path;
      script.setAttribute('data-path', path);

      // IE

      script.onerror = (error: any) => resolve({ loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
}